import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'
import fullScreen from 'lightgallery/plugins/fullscreen'
import Cookie from 'js.cookie';
import L from 'leaflet';
import markerIconPath from 'leaflet/dist/images/marker-icon.png';
import markerShadowPath from 'leaflet/dist/images/marker-shadow.png'
export default {
  init() {
    // Initialization code for all pages (if needed)
  },
  
  finalize() {
    // Finalization code for all pages, after page-specific JS is fired

       /**
     * Open Street Map
     */
    // Create a new default icon using the imported paths
    const DefaultIcon = L.Icon.extend({
      options: {
        iconUrl: markerIconPath,
        shadowUrl: markerShadowPath,
      },
    });

    // Set the new default icon globally
    L.Marker.prototype.options.icon = new DefaultIcon();

    // Check if the map container with id 'map' exists
    const mapElement = document.getElementById('map');
    if (mapElement) {
      // Initialize map without setting a fixed view
      const map = L.map('map');

      // Add OpenStreetMap tiles
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '© OpenStreetMap contributors',
      }).addTo(map);

      // Define marker locations
      const locations = [
        [44.80081898801788, -68.77191289814834], // Marker 1 
      ];

      // Create markers and add them to the map
      const markers = locations.map(coords => L.marker(coords).addTo(map));

      // Bind popups to each marker
      markers[0].bindPopup('<b><a href="https://www.google.com/maps/dir/?api=1&destination=44.80081898801788, -68.77191289814834" target="_blank" rel="noopener noreferrer">Breezy Photography</a></b><br>61 Main Street Suite 33, Bangor, ME 04401');

      // Automatically adjust the map to fit all markers
      const bounds = L.latLngBounds(locations);
      map.fitBounds(bounds);

      markers[0].openPopup();
    }

    // Hamburger toggle functionality
     let removeClass = true;
     $('.hamburger').click(() => {
       $('.hamburger').toggleClass('is-active');
       $('#sideNav').toggleClass('sideNav-open');
       $('.sideNavBody').toggleClass('sideNavBody-push');
       removeClass = false;
     });
 
     $('.sideNav').click(() => {
       removeClass = false;
     });
 
     // Close hamburger menu on touch outside
     $(document).on('click touchstart', (e) => {
        if (removeClass && !$(e.target).hasClass('sideNav') && $('.sideNav').has($(e.target)).length === 0) {
          $('.hamburger').removeClass('is-active');
          $('#sideNav').removeClass('sideNav-open');
          $('.sideNavBody').removeClass('sideNavBody-push');
        }
        removeClass = true;
      });
 
    // Show/hide scroll-to-top button based on scroll position
    $(window).scroll(function() {
      $('.scrollup').toggle($(this).scrollTop() > 100);
    });

    // Scroll-to-top functionality
    $('.scrollup').click(function() {
      $('html, body').animate({
        scrollTop: 0,
      }, 600);
      return false;
    });

    // Dropdown and mobile menu functionality

    // Dropdown on click
    $('.banner ul > li.menu-item-has-children > a').click(function (e) {
      e.preventDefault();
      $(this).parent('.banner ul > li.menu-item-has-children').toggleClass('open');
      $(this).parent('.banner ul > li.menu-item-has-children').siblings('.open').removeClass('open');
    });

    // Close dropdown when clicking anywhere else
    $(document).on('click touch', (e) => {
      if (!$(e.target).hasClass('menu-item-has-childre') && !$(e.target).parents('.banner ul li.menu-item-has-children').length) {
        $('.banner ul li.menu-item-has-children.open').removeClass('open');
      }
    });

    // SideNav dropdown on click
    $('.sideNav li.menu-item-has-children > a').click(function (e) {
      e.preventDefault();
      $(this).next('.sideNav .sub-menu').slideToggle();
      $(this).parent('.sideNav li.menu-item-has-children').toggleClass('open');
    });

    // Close SideNav dropdown on link click
    $('.sideNav .sub-menu li:not(.menu-item-has-children) a').click(() => {
      $('.hamburger').removeClass('is-active');
      $('#sideNav').removeClass('sideNav-open');
      $('.sideNavBody').removeClass('sideNavBody-push');
    });

    // Show modal popup if not dismissed and modal exists
    if (!Cookie.get('alert') && $('#modal').length || $('#modal').hasClass('no-cookie')) {
      $('#modal').show();
      Cookie.remove('alert');
    }

    // Close modal popup on button click
    $('.modal .btn-close').click(function() {
      $('#modal').hide();
      Cookie.set('alert', true, {
        expires: 1,
      });
    });

    // Close alert banner on button click
    if (!Cookie.get('alert_banner')) {
      $('#site-alert-banner').show();
    }
    
    $('#site-alert-banner .btn-close').click(function() {
      $('#site-alert-banner').hide();
      Cookie.set('alert_banner', true, {
        expires: 1,
      });
    });

    //open external links in new tab
    $('a[href^="http"]').each(function() {
      if (this.hostname !== window.location.hostname) {
        $(this).attr('target', '_blank');
      }
    });

    // Add icons to text links that open in a new tab
    $(document).ready(function() {
      const $links = $('a[target="_blank"]').filter(function() {
        return $(this).text().trim().length > 0 && $(this).find('i').length === 0;
      });

      $links.each(function() {
        const href = $(this).attr('href');
        if (href && href.trim().length !== 0 && !href.startsWith('mailto:')) {
          const iconClass = href.endsWith('.pdf') ? 'fa-solid fa-file-pdf' : 'fa-solid fa-square-arrow-up-right';
          $(this).append(` <i class="mx-1 ${iconClass}"></i>`);
        }
      });
    });

    //change height of empty paragraphs
    $('p').each(function() {    // Loop through each paragraph
      if ($(this).html().trim() === '&nbsp;') { // Check if it contains only '&nbsp;'
          $(this).css('height', '0');         // Apply the CSS height
      }
    });

    //testimonials carousel
    if ($('.testimonials-carousel').length) {
      $('.testimonials-carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        appendArrows: '.testimonials-panel .slider-nav',
        appendDots: '.testimonials-panel .slider-nav',
        adaptiveHeight: true,
        arrows: true,
        dots: true,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              dots: false,
            },
          },
        ],
      })
    }

    /**
   * lightgallery
   */
    $('.lightgallery').each(function() {
      lightGallery(this, {
        licenseKey: 'F28B4CA0-283749F1-BBEB75B9-915E2B0B',
        selector: '.gallery-image',
        plugins: [lgZoom, lgThumbnail, fullScreen],
        speed: 500,
        fullScreen: true,
        subHtmlSelectorRelative: true,
        download: false,
        mobileSettings: {
          controls: true,
          showCloseIcon: true,
        },
      });
    });

    //review us page
    $('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
      localStorage.setItem('activeTab', $(e.target).attr('href'));
    });
    // Get the stored active tab from localStorage
    var activeTab = localStorage.getItem('activeTab');
    // If there is no stored active tab or it doesn't exist, set the first tab as active
    if (!activeTab || !$('#review-tab a[href="' + activeTab + '"]').length) {
      $('#review-tab a[data-toggle="tab"]').first().tab('show');
    } else {
      // If there is a stored active tab, show it
      $('#review-tab a[href="' + activeTab + '"]').tab('show');
    }

  },
};
